import React from "react";
import ReactDOM from "react-dom/client";

import { InitializeMessagingHub } from "./sockets/messagingManager";
import App from "./components/app/App";
import AppState from "./foundation/AppState";
import { DisplayType } from "./types/system/DisplayType";
import { CustomConfigSection } from "./state/system/Menu";
import { MenuItem } from "./types/system/MenuItem";
import Configuration from "./foundation/Configuration";
import Datastore from "./communication/Datastore";
import ClientSystem from "./types/core/ClientSystem";

class TimetablingSolutions {
    static async Start(
        menuItems: MenuItem[],
        generalSettings: MenuItem[],
        configSettings: MenuItem[],
        customSections: CustomConfigSection[],
        displaySettings: DisplayType[],
        appLogo: string,
        flatLogo: string,
    ) {
        await Configuration.initialise();
        await new Promise(resolve => {
            if (document.readyState === "complete") {
                resolve(true);
            } else {
                window.addEventListener("load", () => resolve(true));
            }
        });

        const app = await Datastore.getType<ClientSystem>(
            "api/Authentication/Session/ClientSystem",
        );
        if (
            app &&
            app.version?.length &&
            app.version !== Configuration.appVersion
        )
            document.location = app.applicationPath;

        await AppState.instance.getSessionJWT();

        if (!InitializeMessagingHub()) return false;

        const addScript = url => {
            return new Promise(resolve => {
                const element = document.createElement("script");
                element.setAttribute("src", url);
                element.setAttribute("async", "false");
                element.addEventListener("load", resolve);
                document.head.appendChild(element);
            });
        };

        window["_elev"] = window["_elev"] || {};
        window["_elev"].account_id = "584f3bea78d4c";
        addScript(
            "https://cdn.elev.io/sdk/bootloader/v4/elevio-bootloader.js?cid=584f3bea78d4c",
        ).then(() => {
            window["_elev"].q = [];
            window["_elev"].on = (z, y) => window["_elev"].q.push([z, y]);
        });

        ReactDOM.createRoot(document.getElementById("root")).render(
            <>
                <React.StrictMode>
                    <App
                        menuItems={menuItems}
                        generalSettings={generalSettings}
                        configSettings={configSettings}
                        customSections={customSections}
                        displaySettings={displaySettings}
                        appLogo={appLogo}
                        flatLogo={flatLogo}
                    />
                </React.StrictMode>
                <div className="page-elements"></div>
            </>,
        );

        return true;
    }
}

export default TimetablingSolutions;
